import type { WReferenceLinkingToUrlContent } from "@/lib/api/cms-window-content";
import styles from "./WReferenceLinkingToUrlCtaPill.module.css";

/**
 * WReferenceLinkingToUrlCtaPill — area variant renderer dla `w_reference_linking_to_url`
 * uzywany w naglowku (headerCol) jako zielony pill CTA button (np. "Kontakt").
 *
 * Dane wejsciowe identyczne jak default `WReferenceLinkingToUrl`:
 *   - `content.title` = tekst przycisku (imp_cms_window.name)
 *   - `content.config.list_url` = URL docelowy
 *
 * Zarejestrowany w `windowVariants.areaOverrides.w_reference_linking_to_url.headerCol3`.
 */
export default function WReferenceLinkingToUrlCtaPill({
  content,
}: WReferenceLinkingToUrlCtaPillProps) {
  if (!content) return null;
  const { title, config } = content;
  if (!title) return null;

  const label = <span dangerouslySetInnerHTML={{ __html: title }} />;

  return config.list_url ? (
    <a href={config.list_url} className={styles.button}>
      {label}
    </a>
  ) : (
    <span className={styles.button}>{label}</span>
  );
}

export type WReferenceLinkingToUrlCtaPillProps = {
  content: WReferenceLinkingToUrlContent | null;
};
